/*
 * @Author: randy
 * @Date: 2020-07-31 14:29:26
 * @LastEditTime: 2020-08-10 15:32:33
 * @Description: 通用路由
 */
import Page403 from "@/views/error/403";
import Page404 from "@/views/error/404";
import Page500 from "@/views/error/500";
import Privacy from "@/views/privacy/index";

const routes = [
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy
  },
  {
    path: "/403",
    name: "403",
    component: Page403
  },
  {
    path: "/404",
    name: "404",
    component: Page404
  },
  {
    path: "/500",
    name: "500",
    component: Page500
  }
];

export default routes;
